/**
 * isValidKvkNumber
 * Function that validates if a string value is a valid KVK number or not
 * @param value value to validate if it is a KVK number or not
 * @returns boolean
 */
export function isValidKvkNumber(value) {
    if (!value) {
        return false;
    }
    const kvknum = value.replace(/[\D]/gm, '');
    const regex = /^(\d){8}$/;
    if (regex.test(kvknum)) {
        return true;
    }
    return false;
}
